var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2199_19059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.94737 8.19512V14.6829C1.84211 14.2927 1.05263 13.3171 1.05263 12.1463V10.7317C1.05263 9.60975 1.84211 8.58536 2.94737 8.19512ZM4.00001 7.07317C1.78948 7.07317 0 8.7317 0 10.7805V12.1951C0 14.2439 1.78948 15.9024 4.00001 15.9024V7.07317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8947 8.19512C17.9999 8.58536 18.7894 9.56097 18.7894 10.7317V12.1463C18.7894 13.3171 17.9999 14.2927 16.8947 14.6829V8.19512ZM15.842 7.07317V15.8537C18.0526 15.8537 19.842 14.1951 19.842 12.1463V10.7317C19.7894 8.68292 17.9999 7.07317 15.842 7.07317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.842 9.21951H15.7894V7.07316C15.7894 3.85365 13.1578 1.21951 9.89463 1.21951C6.63147 1.21951 3.9999 3.85365 3.9999 7.07316V9.21951H2.94727V7.07316C2.94727 3.31707 6.05252 0.243896 9.89463 0.243896C13.7367 0.243896 16.842 3.31707 16.842 7.07316V9.21951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7896 19.7561V18.7805C13.579 18.7805 15.8422 16.5366 15.8422 13.8049H16.8948C16.8422 17.0732 14.158 19.7561 10.7896 19.7561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94734 15.2683C8.42103 15.2683 6.94734 14.7805 5.73682 13.8537L6.42103 13.1219C8.47366 14.6829 11.4737 14.6829 13.5263 13.1219L14.2105 13.8537C12.9473 14.7805 11.421 15.2683 9.94734 15.2683Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2199_19059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.1bd5fb2adbc9e29f14f1d19d6d52f12b.svg";
export { ForwardRef as ReactComponent };